import React from 'react';
import Icon from '../../../components/AppIcon';

const AdminTools = ({ onToolClick }) => {
  const tools = [
    {
      id: 'audit-trail',
      title: 'Audit Trail',
      description: 'View complete transaction audit logs',
      icon: 'FileText',
      color: 'bg-primary',
      enabled: true
    },
    {
      id: 'regulatory-reports',
      title: 'Regulatory Reports',
      description: 'Generate compliance reports',
      icon: 'BarChart3',
      color: 'bg-secondary',
      enabled: true
    },
    {
      id: 'account-limits',
      title: 'Account Limits',
      description: 'Override customer limits',
      icon: 'Settings',
      color: 'bg-accent',
      enabled: true
    },
    {
      id: 'system-alerts',
      title: 'System Alerts',
      description: 'Configure alert thresholds',
      icon: 'Bell',
      color: 'bg-warning',
      enabled: true
    },
    {
      id: 'user-management',
      title: 'User Management',
      description: 'Manage admin users and roles',
      icon: 'Users',
      color: 'bg-success',
      enabled: true
    },
    {
      id: 'backup-restore',
      title: 'Backup & Restore',
      description: 'System backup operations',
      icon: 'Database',
      color: 'bg-muted',
      enabled: true
    },
    {
      id: 'agent-performance',
      title: 'Agent Performance Analytics',
      description: 'Performance metrics and risk contribution',
      icon: 'TrendingUp',
      color: 'bg-primary',
      enabled: true
    },
    {
      id: 'security-monitor',
      title: 'Security & Platform Health',
      description: 'Security monitoring and system health',
      icon: 'Shield',
      color: 'bg-error',
      enabled: true
    },
    {
      id: 'regulator-reporting',
      title: 'Regulator Reporting',
      description: 'STR/SAR management and oversight',
      icon: 'FileWarning',
      color: 'bg-warning',
      enabled: true
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground flex items-center space-x-2">
          <Icon name="Wrench" size={20} />
          <span>Administrative Tools</span>
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Access advanced administrative functions and system management
        </p>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tools?.map((tool) => (
            <button
              key={tool?.id}
              onClick={() => tool?.enabled && onToolClick(tool?.id)}
              disabled={!tool?.enabled}
              className={`p-4 border border-border rounded-lg text-left group relative overflow-hidden
                ${tool?.enabled 
                  ? 'hover:bg-muted/50 cursor-pointer hover:border-primary/50' :'opacity-50 cursor-not-allowed bg-muted/20'
                }
                transition-all duration-150`}
            >
              {tool?.enabled && (
                <div className="absolute top-2 right-2">
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
                    Active
                  </span>
                </div>
              )}
              <div className="flex items-start space-x-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${tool?.color} 
                  ${tool?.enabled ? 'group-hover:scale-105' : 'opacity-70'} 
                  transition-transform duration-150`}>
                  <Icon name={tool?.icon} size={20} color="white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`font-medium ${tool?.enabled ? 'text-foreground group-hover:text-primary' : 'text-muted-foreground'} 
                    transition-colors duration-150`}>
                    {tool?.title}
                  </p>
                  <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
                    {tool?.description}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminTools;